export default {"src":"/_next/static/media/cadbury.4b5ea7c9.svg","height":121,"width":170,"blurWidth":0,"blurHeight":0};